export default {
  branchconfig: {
    name: 'จัดการสาขา',
    fields: {
      name: 'จัดการสาขา',
      branch_code: 'รหัสสาขา',
      slot: 'จำนวนช่องทั้งหมด',
      open_slot: 'จำนวนช่องที่เปิด',
      open_time: 'เวลาเปิด',
      close_time: 'เวลาปิด',
      branch_name_th: 'ชื่อสาขา (ไทย)',
      branch_name_en: 'ชื่อสาขา (อังกฤษ)',
      branch_name: 'ชื่อสาขา',
      is_close: 'ปิดสาขาเฉพาะวันนี้',
    },
    create: { title: 'สร้างการจัดการสาขา', success: 'สร้างสำเร็จ' },
    edit: { title: 'แก้ไขการจัดการสาขา', success: 'แก้ไขสำเร็จ' },
    show: { title: 'แสดงบริการ' },
  },
}
